module.exports = __webpack_public_path__ + "static/media/N1.1e9ca704.png";